import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../components/sharedcomponents/sidebar/Sidebar";
import UserManagement from "../features/usersmanagement/crud/UserManagement";
import DashboardPage from "../pages/DashboardPage";
import GroupsPage from "../pages/GroupsPage";
import ProfilePage from "../pages/ProfilePage";
import { MenuUnfoldOutlined } from "@ant-design/icons";

const SIDEBAR_W = 256;  

type NavigationComponent = React.FC & {
  DashboardPage: React.FC;
  UserManagement: React.FC;
  GroupsPage: React.FC;
  ProfilePage: React.FC;
};

const Navigation: NavigationComponent = () => {
  const navigate  = useNavigate();
  const location  = useLocation();

   const [isOpen, setIsOpen] = useState(() => window.innerWidth >= 1024);
    const [isDesktop, setIsDesktop] = useState(() => window.innerWidth >= 1024);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    const handler = (e: MediaQueryListEvent) => {
      setIsDesktop(e.matches);
       setIsOpen(e.matches);
    };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

   useEffect(() => {
    if (!isDesktop) setIsOpen(false);
  }, [location.pathname, isDesktop]);

  const handleMenuSelect = (menuId: string) => {
    switch (menuId) {
      case "tableau de bord":   navigate("/accueil");      break;
      case "gestion-user":      navigate("/utilisateurs"); break;
      case "gestion-websites":  navigate("/sites-web");    break;
      default:                  navigate("/accueil");      break;
    }
  };

  return (
    <div className="min-h-screen bg-[#EBF5FF] flex">

      <Sidebar
        isOpen={isOpen}
        isLocked={isDesktop}        
        onClose={() => setIsOpen(false)}
        onToggle={() => setIsOpen((p) => !p)}
        activeMenu=""
        onMenuSelect={handleMenuSelect}
      />

       {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed top-4 left-4 z-[900] bg-white text-[#0F52BA] p-2.5 rounded-xl
            shadow-md border border-slate-100
            hover:bg-blue-50 hover:border-blue-100
            active:scale-95 transition-all duration-150 cursor-pointer
            flex items-center justify-center"
          aria-label="Ouvrir le menu"
        >
          <MenuUnfoldOutlined style={{ fontSize: 20 }} />
        </button>
      )}

       
      <main
        className="flex-1 min-h-screen transition-[margin] duration-300 ease-in-out"
        style={{ marginLeft: isDesktop && isOpen ? SIDEBAR_W : 0 }}
      >
         <div
          key={location.pathname}
          className="p-3 w-full page-transition lg:pt-3 pt-14"
        >
          <Outlet />
        </div>
      </main>
    </div>
  );
};

Navigation.DashboardPage  = DashboardPage;
Navigation.UserManagement = UserManagement;
Navigation.GroupsPage     = GroupsPage;
Navigation.ProfilePage    = ProfilePage;

export default Navigation;